module.exports = __webpack_public_path__ + "static/media/ict_support.f2b555e7.jpg";